import {
  getExamSubquestions,
} from "./examQuestionParser";

export function getSessionModeLabel(
  selectionType,
  language
) {
  const labels = {
    AREAS_FOR_IMPROVEMENT: {
      en: "Areas for Improvement",
      af: "Gebiede vir verbetering",
    },
    STANDARD: {
      en: "Standard",
      af: "Standaard",
    },
    CHALLENGING: {
      en: "Challenging",
      af: "Uitdagend",
    },
    EXAM: {
      en: "Exam",
      af: "Eksamen",
    },
  };

  return labels[selectionType]?.[language] ||
    (language === "af"
      ? "Tutorsessie"
      : "Tutor session");
}

export function buildCompletedPaperParts(question) {
  const answers = Array.isArray(question?.answers)
    ? question.answers
    : [];
  const subquestions =
    getExamSubquestions(question);

  if (subquestions.length === 0) {
    return [
      {
        number: question.question_number,
        marks: Number(question.marks || 0),
        questionText: question.question_text,
        answers,
      },
    ];
  }

  return subquestions.map((subquestion) => ({
    number: subquestion.number,
    marks: Number(subquestion.marks || 0),
    questionText: subquestion.questionText,
    answers: answers.filter(
      (answer) =>
        answer.subquestion_number ===
        subquestion.number
    ),
  }));
}
